import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-phone',
  styleUrls: ['./phone.component.scss'],
  templateUrl: './phone.component.html'
})
export class PhoneComponent {}
